import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import Modal from '../Modal';
import {
  changeName as actionChangeName,
  updateProfile as actionUpdateProfile,
  changeSendEmails as actionChangeSendEmails,
  changeSendLessonSmsNotifications as actionChangeSendLessonSmsNotifications,
  checkNickname,
} from '../../actions/auth';
import TimeZoneSelect from '@ui/TimeZoneSelect';
import { getTimeZone } from '@utils/date';

import CheckBox from '../utils/CheckBox';
import './settings-rts.scss';

class EditProfile extends React.PureComponent {
  constructor(...args) {
    super(...args);

    this.handleNicknameChange = this.handleNicknameChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleRealNameChange = this.handleRealNameChange.bind(this);
    this.handleTimeZoneChange = this.handleTimeZoneChange.bind(this);
    this.handleTelegramIdChange = this.handleTelegramIdChange.bind(this);
    this.saveProfile = this.saveProfile.bind(this);
    this.handleSendEmails = this.handleSendEmails.bind(this);
    this.handleSendLessonSmsNotifications = this.handleSendLessonSmsNotifications.bind(
      this
    );

    const user = this.props.user;
    this.state = {
      nickname: user.name,
      phone: user.phone,
      realname: user.realname,
      telegramId: user.telegramId,
      timezone: user.timezone || getTimeZone(),
      sendEmails: user && user.sendEmails,
      sendLessonSmsNotifications: user && user.sendLessonSmsNotifications,
      nicknameValid: true,
    };
  }

  handleNicknameChange(event) {
    const nickname = event.target.value;
    const { dispatch } = this.props;
    const nicknameValid = nickname.match(/^[a-zA-Z0-9_]{3,16}$/);

    if (nicknameValid) {
      dispatch(checkNickname(nickname));
    }

    this.setState({ nickname, nicknameValid });
  }

  handlePhoneChange(event) {
    this.setState({ phone: event.target.value });
  }

  handleRealNameChange(event) {
    this.setState({ realname: event.target.value });
  }

  handleTelegramIdChange(event) {
    this.setState({ telegramId: event.target.value });
  }

  handleTimeZoneChange(timezone) {
    this.setState({ timezone });
  }

  saveProfile() {
    const { dispatch } = this.props;
    dispatch(
      actionUpdateProfile({
        nick: this.state.nickname,
        phone: this.state.phone,
        timezone: this.state.timezone,
        realname: this.state.realname,
        telegramId: this.state.telegramId,
      })
    );
    this.props.close();
  }

  handleSendEmails(sendEmails) {
    this.setState({ sendEmails });
    this.props.dispatch(actionChangeSendEmails(sendEmails));
  }

  handleSendLessonSmsNotifications(sendLessonSmsNotifications) {
    this.setState({ sendLessonSmsNotifications });
    this.props.dispatch(
      actionChangeSendLessonSmsNotifications(sendLessonSmsNotifications)
    );
  }

  render() {
    const {
      nickname,
      phone,
      realname,
      telegramId,
      timezone,
      nicknameValid,
      sendEmails,
      sendLessonSmsNotifications,
    } = this.state;
    const { show, close, user, nicknameFree, hideButtons } = this.props;

    let nickEnabled = nicknameValid && nicknameFree;
    if (!nicknameFree && user.name === nickname) {
      nickEnabled = true;
    }

    let nicknameClass = '';
    let nicknameMessage = '';
    if (nickname) {
      nicknameClass =
        nicknameValid && nicknameFree ? 'has-success' : 'has-error';
      if (nicknameValid && !nicknameFree && user.name !== nickname) {
        nicknameMessage = <Translate value="register.errors.nickname.taken" />;
      } else if (!nicknameValid) {
        nicknameMessage = <Translate value="register.errors.nickname.wrong" />;
      }
    }

    return (
      <Modal
        show={show}
        close={close}
        hideClose
        dialogClassName="rts-settings-modal"
        id="modal-editProfile"
      >
        <div className="rts-settings-modal__inner">
          <div className="rts-settings-modal__header">
            <h2 className="rts-settings-modal__title">
              <Translate value="settings.personal.game.edit" />
            </h2>
            <button
              type="button"
              className="rts-settings-modal__close"
              onClick={close}
              aria-label="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>

          <div className="rts-settings-modal__body">
            <div className={`rts-settings-modal__field ${nicknameClass}`}>
              <span>Игровой ник</span>
              <input
                type="text"
                className="form-control"
                placeholder={I18n.t('settings.personal.editProfile.newNick')}
                value={nickname}
                onChange={this.handleNicknameChange}
                autoComplete="username"
              />
              {nicknameMessage && (
                <span className="help-block">{nicknameMessage}</span>
              )}
            </div>

            <div className="rts-settings-modal__field">
              <span>Имя</span>
              <input
                type="text"
                className="form-control"
                placeholder="Ваше имя"
                value={realname}
                onChange={this.handleRealNameChange}
              />
            </div>

            <div className="rts-settings-modal__field">
              <span>Telegram ID</span>
              <input
                type="text"
                className="form-control"
                placeholder="Telegram ID"
                value={telegramId}
                onChange={this.handleTelegramIdChange}
              />
            </div>

            <div className="rts-settings-modal__field hidden-settings-item">
              <span>Телефон</span>
              <input
                type="text"
                className="form-control"
                placeholder="Ваш телефон"
                value={phone}
                onChange={this.handlePhoneChange}
              />
            </div>

            <div className="rts-settings-modal__field rts-settings-modal__field--timezone">
              <span>Часовой пояс</span>
              <TimeZoneSelect
                classNamePrefix="rts-timezone"
                value={timezone}
                onChange={this.handleTimeZoneChange}
              />
            </div>

            {!hideButtons && (
              <div className="hidden-settings-item">
                <CheckBox
                  onChange={this.handleSendLessonSmsNotifications}
                  checked={sendLessonSmsNotifications}
                >
                  <Translate
                    className="text-muted"
                    value="settings.personal.sendLessonSms"
                  />
                </CheckBox>
                <br />
                <CheckBox onChange={this.handleSendEmails} checked={sendEmails}>
                  <Translate
                    className="text-muted"
                    value="register.personal.email"
                  />
                </CheckBox>
              </div>
            )}
          </div>

          {!hideButtons && (
            <div className="rts-settings-modal__footer">
              <button
                type="button"
                className="rts-settings-modal__btn rts-settings-modal__btn--primary"
                disabled={!nickEnabled}
                onClick={this.saveProfile}
              >
                <Translate value="settings.personal.game.change" />
              </button>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

EditProfile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.any.isRequired,
  hasPassword: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    hasPassword: state.auth.hasPassword,
    nicknameFree: state.register.nicknameFree,
  };
}

export default connect(mapStateToProps)(EditProfile);
